import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseConfigApi } from "../../Services/API/BaseConfigApi";
import { ADD_PERSON } from "../../Constants/Person";

/**
 * Method to add person
 */
export const AddPerson = createAsyncThunk(
  ADD_PERSON,
  async (payload: FormData, thunkAPI) => {
    try {
      const headers = {
        "content-type": "multipart/form-data",
      };
      const response = await BaseConfigApi.post(`/person`, payload, {
        headers: headers,
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
